import { admin_module_names } from './AdminModuleNamesInDB';

export interface CustomRouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  extralink: boolean;
  submenu: CustomRouteInfo[];
  module_name: string;
}

export const ADMIN_ROUTES: CustomRouteInfo[] = [
  {
    path: '',
    title: '',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/dashboard',
        title: 'Dashboard',
        icon: 'mdi mdi-information',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.dashboard_module,
      },
    ],
    module_name: admin_module_names.dashboard_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-account-group',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/customers',
        title: 'Customers',
        icon: 'mdi mdi-account-edit',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.customer_management_module,
      },
    ],
    module_name: admin_module_names.customer_management_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-credit-card-check',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/subscription-plans',
        title: 'Plans',
        icon: 'mdi mdi-pencil-box',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.subscription_plan_management_module,
      },
    ],
    module_name: admin_module_names.subscription_plan_management_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-cart',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/orders',
        title: 'Orders',
        icon: 'mdi mdi-cart',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.order_management_module,
      },
    ],
    module_name: admin_module_names.order_management_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-access-point-network',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/broadcast',
        title: 'Broadcast',
        icon: 'mdi mdi-access-point-network',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.broadcast_management_module,
      },
    ],
    module_name: admin_module_names.broadcast_management_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-account-search',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/leads',
        title: 'Leads',
        icon: 'mdi mdi-account-star',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.leads_module,
      },
    ],
    module_name: admin_module_names.leads_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-account-multiple-plus',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/referrals',
        title: 'Referrals',
        icon: 'mdi mdi-account-network',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.referrals_module,
      },
    ],
    module_name: admin_module_names.referrals_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-cog-outline',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/settings',
        title: 'Commission',
        icon: 'mdi mdi-cog-outline',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.setting_module,
      },
    ],
    module_name: admin_module_names.setting_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-file-chart',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/reports',
        title: 'Audit Log',
        icon: 'mdi mdi-chart-line',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.reports_module,
      },
    ],
    module_name: admin_module_names.reports_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-file-chart',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/support-ticket',
        title: 'Support Ticket',
        icon: 'mdi mdi-ticket-account',
        class: '',
        extralink: false,
        submenu: [],
        module_name: admin_module_names.support_ticket_module,
      },
    ],
    module_name: admin_module_names.support_ticket_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-shield-account',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/admin/access-control/users',
        title: 'Admin Users',
        icon: 'mdi mdi-account-multiple',
        class: '',
        extralink: false,
        submenu: [],
        // Sidebar filter shows this entry if the role has any AdminUsers permission.
        module_name: admin_module_names.admin_users_module,
      },
      {
        path: '/admin/access-control/roles',
        title: 'Roles',
        icon: 'mdi mdi-shield-key',
        class: '',
        extralink: false,
        submenu: [],
        // Roles is its own module — gated independently of AdminUsers.
        module_name: admin_module_names.roles_module,
      },
    ],
    // Parent group's module_name is just a label hint; the per-submenu module_name
    // is what the sidebar filter uses to decide visibility.
    module_name: admin_module_names.admin_users_module,
  },
];
